// BM-H398 - section key to component. The single place the page looks up
// which component writes which `submission.answers` key.

import S1Testator from "./S1Testator";
import S2Family from "./S2Family";
import S2aJointAssets from "./S2aJointAssets";
import S2bShares from "./S2bShares";
import S3Executors from "./S3Executors";
import S4Guardians from "./S4Guardians";
import S5Structure from "./S5Structure";
import S6Legacies from "./S6Legacies";
import S7Residue from "./S7Residue";
import S8Digital from "./S8Digital";
import S9Funeral from "./S9Funeral";
import S10Exclusions from "./S10Exclusions";
import S11LetterOfWishes from "./S11LetterOfWishes";
import G3MarriageInContemplation from "./G3MarriageInContemplation";

export const SECTION_COMPONENTS = Object.freeze({
  s1_testator: S1Testator,
  s2_family: S2Family,
  g3_marriage: G3MarriageInContemplation,
  s2a_joint_assets: S2aJointAssets,
  s2b_shares: S2bShares,
  s3_executors: S3Executors,
  s4_guardians: S4Guardians,
  s5_structure: S5Structure,
  s6_legacies: S6Legacies,
  s7_residue: S7Residue,
  s8_digital: S8Digital,
  s9_funeral: S9Funeral,
  s10_exclusions: S10Exclusions,
  s11_letter_of_wishes: S11LetterOfWishes,
});
